module.exports = __webpack_public_path__ + "static/media/novex-white.fe75c946.png";